/**
 * Base dependencies
 */
import * as $ from 'jquery';

require('@iim/jquery-upload/jquery.upload.js');
window.$ = $;
window.jQuery = $;

import 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle';
import '@babel/polyfill/dist/polyfill.js';
import DOMPurify from 'dompurify';
window.DOMPurify = DOMPurify;
import moment from 'moment/moment'
window.moment = moment;
import 'tooltipster/dist/js/tooltipster.bundle.min.js';
import 'bootstrap-notify/bootstrap-notify.js';
import 'chosen-js/chosen.jquery.js';
import 'hogan.js/web/builds/3.0.2/hogan-3.0.2.min.js';
import 'jquery-form/dist/jquery.form.min.js';
import 'sidr/dist/jquery.sidr.js';
import 'jstree/dist/jstree.js';
import tableExport from '@iim/table-export/table-export.module.js';
$.fn.extend(tableExport.tableExport);
$.ajax = tableExport.ajaxBase64Extension($.ajax);
import '@iim/table-export/jquery.base64.js';
import '@iim/table-export/jspdf/libs/sprintf.js';
import '@iim/table-export/jspdf/jspdf.js';
import '@iim/table-export/jspdf/libs/base64.js';

import '@iim/corejs-typeahead/dist/typeahead.bundle.js';
import 'select2/dist/js/select2.js';
import 'chart.js/dist/Chart.js';
import 'event-source-polyfill/src/eventsource.js';
window.EventSourcePolyfill = EventSourcePolyfill;

/**
 * Sentry
 */
import * as Sentry from '@sentry/browser';
window.Sentry = Sentry;

/**
 * Web Components
 */
import '@iim/web-components/dist/iim-checkbox.js';

/**
 * Custom
 */
import {NumberFormatter} from  './custom_components/js/number-util';
window.NumberFormatter = NumberFormatter;

$('[data-toggle="tooltip"]').tooltip({
    container: 'body'
});

moment.locale('de');

/**
 * Angular
 */
import './angular';

import './custom_components/js/basket/UniteBasketUpdate';
import './custom_components/js/basket/internalNoteAutosave';
import './custom_components/js/purchase-requisition/purchase-requisition.util';
import './custom_components/js/invoice.util';



